"use strict";

import Vue from 'vue'

const EventBus = new Vue()

export default EventBus;



// WEBPACK FOOTER //
// ./resources/score/vue/events/event-bus.js